var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFilterIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 16,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#filterIconMultiColor_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M5.862 1.747A1.196 1.196 0 0 1 6.96 1H18c.477 0 .906.294 1.098.747.192.453.108.984-.216 1.35L14.4 8.172V13a1 1 0 0 1-.531.894.927.927 0 0 1-1.005-.094l-1.92-1.5a1.008 1.008 0 0 1-.384-.8V8.172L6.078 3.097a1.294 1.294 0 0 1-.216-1.35Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M1.2 3h3.723c.096.281.246.544.447.772l4.23 4.79v.522l-.96 1.088V14c0 .378-.204.725-.531.894a.927.927 0 0 1-1.005-.094l-1.92-1.5a1.008 1.008 0 0 1-.384-.8v-2.328L.318 5.097a1.288 1.288 0 0 1-.216-1.35A1.194 1.194 0 0 1 1.2 3Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "filterIconMultiColor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19.2v16H0z"
})))));
export default SvgFilterIconMultiColor;